<div class="treeslo-paginator-cursor-based-root">
    <div class="paginator-row">
        <div class="page-size-select">
            <span class="page-size-label">Items per page</span>
            <mat-form-field appearance="outline" class="page-size-form-field hide-hint">
                <mat-select panelClass="page-size-panel" [value]="pageSizeValue"
                    [disabled]="pageSizeDisabled" (selectionChange)="onPageSizeChange($event.value)">
                    <mat-option *ngFor="let option of pageSizeOptions" [value]="option">
                        {{ option }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="nav-buttons">
            <button type="button" class="nav-button" [disabled]="!canPrev" (click)="onPrev()"
                aria-label="Previous page">
                <i-tabler name="chevron-left" class="icon-18"></i-tabler>
            </button>
            <button type="button" class="nav-button" [disabled]="!canNext" (click)="onNext()" aria-label="Next page">
                <i-tabler name="chevron-right" class="icon-18"></i-tabler>
            </button>
        </div>
    </div>
</div>